import type { LucideIcon } from 'lucide-react'
import type { ButtonHTMLAttributes } from 'react'
import { mergeClassNames } from '@/design-system/lib/mergeClassNames'

export type IconButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger'

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: LucideIcon
  label: string
  variant?: IconButtonVariant
}

export function IconButton({
  icon: Icon,
  label,
  variant = 'ghost',
  className,
  type = 'button',
  ...props
}: IconButtonProps) {
  return (
    <button
      aria-label={label}
      className={mergeClassNames('ds-icon-button', `ds-icon-button--${variant}`, className)}
      type={type}
      {...props}
    >
      <Icon aria-hidden="true" />
    </button>
  )
}
